import React from "react";

function Optimization() {
  return (
    <div className="optimization-bg">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-10 col-md-12 col-sm-12 mt-5 mb-5">
            <h1 className="Text-heading text-center" data-aos="fade-up">
              Custom Chatbot Development Solutions
            </h1>
            <p className="text-center text-detail mt-2" data-aos="fade-up">
              Improve your business operations and take the user experience to
              the next level with innovative chatbot solutions moulded to your
              business needs.
            </p>
            <div className="text-center" data-aos="fade-up">
              <button className="btn btn-experts p-3">
                Contact Our Experts
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Optimization;
